import { ReactNode } from 'react'
import { cn } from 'src/shared/components/ui/utils'
import {
  DASHBOARD_ORDER_ROW_HEIGHT,
  DASHBOARD_VISIBLE_ORDER_ITEMS,
} from '../consts'

export const FadedOrderList = ({
  children,
  fadeClassName,
  showFade = true,
}: {
  children: ReactNode
  fadeClassName: string
  showFade?: boolean
}) => {
  const maxHeight = DASHBOARD_ORDER_ROW_HEIGHT * DASHBOARD_VISIBLE_ORDER_ITEMS

  return (
    <div className="relative -mx-1">
      <div
        className="overflow-y-auto scrollbar-hide"
        style={{ maxHeight }}
      >
        {children}
      </div>
      {showFade && (
        <div
          className={cn(
            'pointer-events-none absolute inset-x-0 bottom-0 h-8',
            fadeClassName
          )}
          aria-hidden
        />
      )}
    </div>
  )
}
